import React, { Component } from 'react';
import { MAX_QUANTITY} from '../shared/cart';

export default class ModalOrderSummaryItem extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { lastOrderCart, product, index} = this.props;

    // handle null/undefined values in cart (position 0, reserved for FS)
    if (!product) return <tr />

    let oldPrice = product.computed_price;
    let eNewPrice = '';
    let ePromoBlurb = '';
    let eOldPrice = (<span>{'$' + parseFloat(oldPrice).toFixed(2)}</span>);

    let hasPromo = (lastOrderCart.promo && lastOrderCart.promo_items[index]) ? true : false;
    let creditCount = product.creditArr ? product.creditArr.filter( x => x === true ).length : (product.credit === true ? 1 : 0);
    let fullCredit = (creditCount === product.quantity) ? true : false;
    let specialPrice = product.subPrices ? product.subPrices.filter( x => x < product.sale_price && x > 0).length > 0 : false;

    if(fullCredit){
      eOldPrice = (<span>{ 'Credit' + (creditCount > 1 ? "s" : "")}</span>)
    } else if (hasPromo || specialPrice){
      if(hasPromo)
        ePromoBlurb = <div className="promo-desc">{lastOrderCart.promo.promo_code}</div>;
      oldPrice = product.sale_price * product.quantity;
      eOldPrice = <span className='price-old'>{'$' + parseFloat(oldPrice).toFixed(2)}</span>
      eNewPrice = <div className="price-new">{'$' + product.computed_price.toFixed(2)}</div>;
    } else if( creditCount > 0){
      oldPrice = product.sale_price * product.quantity;
      eOldPrice = <span className='price-credit'>{'$' + parseFloat(oldPrice).toFixed(2)}</span>
      eNewPrice = <div>{'$' + product.computed_price.toFixed(2)}</div>;
    }


    const sImageSrc = '//s3.amazonaws.com/bookspan-media/covers/thumb/' + product.mmid + '.jpg';

    return (
      <tr>
        <td className="col-1">
          <div>
            <img src={sImageSrc} />
          </div>
        </td>
        <td className="col-2">
          <span className="title">{product.title}</span>
          {ePromoBlurb}
        </td>
        <td className="col-3 text-right">
          {eOldPrice}
          {eNewPrice}
          <div className="select-wrapper small">
            <select className="right quantity" onChange={() => {}} value={product.quantity ? product.quantity.toString() : "1"} disabled>
              { new Array(MAX_QUANTITY).fill().map( (x, i) => (<option value={i+1}>{i+1}</option>) ) }
            </select>
          </div>
        </td>
      </tr>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/ModalOrderSummaryItem.jsx